import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentSync, EditableDBItemV3, getElementCenterPos, LL_H_C, LL_V_L, ModuleFE_MouseInteractivity, mouseInteractivity_PopUp, TS_Tabs } from '@nu-art/thunderstorm-frontend';
import { Manager_DiseaseProfile_MultiVarTab_Description, Manager_DiseaseProfile_MultiVarTab_References, Manager_DiseaseProfile_MultiVarTab_Values } from '../../types.js';
import { defaultVPName_Imaging, getCleanDiseaseValue } from '@app/dp-shared';
import { asArray, BadImplementationException, MUSTNeverHappenException, sortArray, voidFunction } from '@nu-art/ts-common';
import { ModuleFE_DiseaseProfile, ModuleFE_DiseaseValue, ModuleFE_DiseaseView, ModuleFE_MultiVar } from '../../../../../_entity.js';
import './Editor_MultiVar.scss';
import { ModuleFE_Variable } from '@app/hcs-frontend';
import { Editor_MultiVar_Description } from './tabs/Editor_MultiVar_Description/Editor_MultiVar_Description.js';
import { Editor_MultiVar_References } from './tabs/Editor_MultiVar_References/Editor_MultiVar_References.js';
import { Editor_MultiVar_Values } from './tabs/Editor_MutliVar_Values/Editor_MultiVar_Values.js';
import { Dialog_Confirmation, ICONS } from '@app/styles';
import { Toaster } from '@nu-art/toasting';
export class Editor_MultiVar extends ComponentSync {
    toaster = new Toaster('multi-var');
    // ######################## Life Cycle ########################
    __onMultiVarUpdated = (...params) => {
        const updatedMultiVar = asArray(params[1]).find(mv => mv._id === this.state.editable.item._id);
        if (!updatedMultiVar)
            return;
        this.setState({ editable: this.getEditable(updatedMultiVar._id) });
    };
    __onDiseaseValueUpdated = (...params) => {
        const mvId = this.state.editable.item._id;
        if (!asArray(params[1]).some(dv => dv.multiVarId === mvId))
            return;
        this.setState({ diseaseValues: this.getDiseaseValues(mvId, this.state.editableDP.item._id, this.state.renderArgs.editMode) });
    };
    deriveStateFromProps(nextProps, state) {
        state.tabId = nextProps.tabId;
        state.renderArgs = nextProps.renderArgs;
        state.editable = this.getEditable(state.renderArgs.multiVar.id);
        state.editableDP = this.getEditableDP(state.renderArgs.itemId);
        state.diseaseValues = this.getDiseaseValues(state.editable.item._id, state.editableDP.item._id, state.renderArgs.editMode);
        return state;
    }
    // ######################## Logic ########################
    getDiseaseValues(mvId, dpId, editMode) {
        const dvs = sortArray(ModuleFE_DiseaseValue.cache.filter(dv => dv.multiVarId === mvId), dv => dv.__created);
        if (editMode && mvId && dpId)
            dvs.push(getCleanDiseaseValue(dpId, mvId));
        return dvs;
    }
    getEditable(mvId) {
        const multiVar = ModuleFE_MultiVar.cache.unique(mvId);
        if (!multiVar)
            throw new BadImplementationException(`Could not find multi-var for id ${mvId}`);
        return new EditableDBItemV3(multiVar, ModuleFE_MultiVar)
            .setAutoSave(true)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(() => this.forceUpdate())
            .setDebounceTimeout(200);
    }
    getEditableDP(dpId) {
        if (!dpId)
            throw new BadImplementationException('Calling Editor_MultiVar with no dp id in renderArgs');
        const dp = ModuleFE_DiseaseProfile.cache.unique(dpId);
        if (!dp)
            throw new MUSTNeverHappenException(`Could not get DP for id ${dpId}`);
        return new EditableDBItemV3(dp, ModuleFE_DiseaseProfile)
            .setAutoSave(true)
            .setOnChanged(async () => this.forceUpdate())
            .setOnSaveCompleted(() => this.forceUpdate())
            .setDebounceTimeout(200);
    }
    isUnderImagingView = () => {
        const connectedView = ModuleFE_DiseaseView.getMVConnectedView(this.state.editable.item);
        return connectedView?.label === defaultVPName_Imaging;
    };
    getTabs = () => {
        return [
            {
                uid: Manager_DiseaseProfile_MultiVarTab_Description,
                title: 'Description',
                content: () => _jsx(Editor_MultiVar_Description, { editable: this.state.editable, editableDP: this.state.editableDP, editMode: this.state.renderArgs.editMode })
            },
            {
                uid: Manager_DiseaseProfile_MultiVarTab_Values,
                title: 'Values',
                content: () => {
                    return _jsx(Editor_MultiVar_Values, { diseaseValues: this.state.diseaseValues, editMode: this.state.renderArgs.editMode, showSourceEditor: this.isUnderImagingView() });
                },
            },
            {
                uid: Manager_DiseaseProfile_MultiVarTab_References,
                title: 'References',
                content: () => _jsx(Editor_MultiVar_References, { editable: this.state.editable, editMode: this.state.renderArgs.editMode, profileReferenceIds: this.state.editableDP.item.referenceIds ?? [] }),
            },
        ];
    };
    onTabSelected = (tabKey) => {
        const args = { ...this.state.renderArgs.multiVar, selectedTab: tabKey };
        this.props.workHubItem.updateArgs(this.state.tabId, { multiVar: args });
    };
    getMVLabel = () => {
        const variable = ModuleFE_Variable.cache.unique(this.state.editable.item._firstVarId);
        return variable?.name ?? 'N/A';
    };
    openMenu = (e) => {
        const model = {
            id: 'multi-var-menu',
            originPos: getElementCenterPos(e.currentTarget),
            modalPos: { x: -1, y: 1 },
            xAxisAnchor: 'right',
            offset: { x: 8 },
            content: () => _jsx(_Fragment, { children: _jsx(Button, { onClick: () => {
                        ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                        Dialog_Confirmation.show({
                            header: 'Are you sure?',
                            content: () => _jsxs(_Fragment, { children: [_jsx("div", { children: "Delete Multi Var" }), _jsx("div", { children: "And all connected disease values" })] }),
                            buttons: [
                                {
                                    label: 'Delete',
                                    isAsync: true,
                                    action: async () => {
                                        try {
                                            //Deselect multi-var, delete & report
                                            this.props.workHubItem.updateArgs(this.state.tabId, {
                                                multiVar: {
                                                    ...this.state.renderArgs.multiVar,
                                                    id: undefined,
                                                }
                                            });
                                            await ModuleFE_MultiVar._v1.deleteMultiVar({ multiVarId: this.state.editable.item._id }).executeSync();
                                            this.toaster.toastSuccess({ title: 'Multi Var Delete', body: 'Multi-var and associated disease values deleted successfully' });
                                        }
                                        catch (err) {
                                            this.logError(err);
                                            this.toaster.toastError({ title: 'Multi Var Delete', body: `Multi var deletion failed:\n${err.message}` });
                                        }
                                        finally {
                                            ModuleFE_MouseInteractivity.hide(mouseInteractivity_PopUp);
                                        }
                                    }
                                },
                                {
                                    label: 'Cancel',
                                    isPreferred: true,
                                    action: voidFunction,
                                }
                            ]
                        });
                    }, children: "Delete" }) }),
        };
        ModuleFE_MouseInteractivity.showContent(model);
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'e__multi-var', children: [this.render_Header(), _jsx(TS_Tabs, { tabs: this.getTabs(), selectedTabId: this.state.renderArgs.multiVar.selectedTab, onSelected: this.onTabSelected })] });
    }
    render_Header = () => {
        return _jsxs(LL_H_C, { className: 'e__multi-var__header', children: [_jsx("div", { className: 'e__multi-var__header-title', children: this.getMVLabel() }), this.state.renderArgs.editMode && _jsx(ICONS.more.component, { onClick: this.openMenu })] });
    };
}
//# sourceMappingURL=Editor_MultiVar.js.map